import React from "react";
import { ViewLead } from "./ViewLeadShared";

/** Training lead detail view (`/training-leads/:id/view`). */
function ViewTrainingLead(props) {
  return <ViewLead {...props} type="training-lead" />;
}

export default ViewTrainingLead;
